/**
 * client/src/components/command/WarningBanner.jsx
 *
 * Displays best-practice violation warnings returned by Claude.
 * Shown above the chat when bestPracticeViolation is true.
 * User can dismiss (acknowledges the warning and proceeds).
 */

export function WarningBanner({ warning, onDismiss }) {
  if (!warning) return null;

  return (
    <div className="mx-3 mb-3 rounded-lg border border-amber-500/40 bg-amber-950/30 px-4 py-3 text-sm">
      <div className="flex items-start gap-3">
        {/* Icon */}
        <span className="mt-0.5 flex-shrink-0 text-amber-400" aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 3.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 4.5zm0 6.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z"/>
          </svg>
        </span>

        {/* Content */}
        <div className="flex-1">
          <p className="font-medium text-amber-300">Best Practice Warning</p>
          <p className="mt-0.5 text-amber-200/80">{warning}</p>
        </div>

        {/* Dismiss */}
        <button
          onClick={onDismiss}
          className="flex-shrink-0 rounded p-1 text-amber-400/60 transition hover:text-amber-300 focus:outline-none"
          aria-label="Dismiss warning"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M2.22 2.22a.75.75 0 0 1 1.06 0L6 4.94l2.72-2.72a.75.75 0 1 1 1.06 1.06L7.06 6l2.72 2.72a.75.75 0 1 1-1.06 1.06L6 7.06 3.28 9.78a.75.75 0 0 1-1.06-1.06L4.94 6 2.22 3.28a.75.75 0 0 1 0-1.06z"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
